import { OperatorsApiService } from '@modules/additional/operators/_services';

export const DEPENDENCY_TYPE = { Machine: 'machine', Location: 'location' };

export const REQUEST = {
  machine: [OperatorsApiService.addMachine, OperatorsApiService.removeMachine],
  location: [OperatorsApiService.addLocation, OperatorsApiService.removeLocation],
};

export const LOADING_FLAGS = {
  addMachineLoading: false,
  removeMachineLoading: false,
  addLocationLoading: false,
  removeLocationLoading: false,
};

export const LOADING_FLAG_NAME = {
  machine: ['addMachineLoading', 'removeMachineLoading'],
  location: ['addLocationLoading', 'removeLocationLoading'],
};

export const DEPENDENCY_NAME = { machine: 'Machine', location: 'Location' };

export const DATA_PROP_NAME = { machine: 'addedMachine', location: 'addedLocation' };

export const PROPS = {
  operatorId: {
    type: [String, Number],
    required: true,
  },

  operatorName: {
    type: String,
    required: true,
  },

  machines: {
    type: Array,
    required: true,
  },

  locations: {
    type: Array,
    required: true,
  },
};
